
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(67),
  playerId: Number.withConstraint(x => x >= 1),
  sessionId: Number.withConstraint(x => x >= 1),
  clickSourceId: Number.withConstraint(x => x >= 0),
  event_mapping_version: Literal(2),
}).And(Partial({
  client_timestamp: Number.withConstraint(x => x >= 0),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(67),
  playerId: Number.withConstraint(x => x >= 1),
  sessionId: Number.withConstraint(x => x >= 1),
  clickSourceId: Number.withConstraint(x => x >= 0),
  event_mapping_version: Literal(2),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 1 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 1 && x <= 1000),
}).And(Partial({
  client_timestamp: Number.withConstraint(x => x >= 0),
  storeId: Number.withConstraint(x => x >= 0 && x <= 50),
  deviceId: Number.withConstraint(x => x >= 0 && x <= 50),
  connectionType: String.withConstraint(x => x.length <= 10),
  zoneId: Number.withConstraint(x => x >= 0),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 67;
  